import { AbstractEntity } from "../AbstractEntity";
export default class Checklists extends AbstractEntity {
    name;
    type;
    constructor(name, type) {
        super();
        this.name = name;
        this.type = type;
    }
}
//# sourceMappingURL=Checklists.js.map